import { render } from "./ThresholdAddEditModal.vue?vue&type=template&id=3511102a&scoped=true"
import script from "./ThresholdAddEditModal.js?vue&type=script&lang=js"
export * from "./ThresholdAddEditModal.js?vue&type=script&lang=js"

import "./ThresholdAddEditModal.vue?vue&type=style&index=0&id=3511102a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3511102a"]])

export default __exports__